"use client";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@pex/ui-web";

const TESTIMONIALS = [
  {
    quote:
      "\u201CI really enjoyed each module. Each one had something that I could really take out and learn from.\u201D",
    name: "Andrea",
  },
  {
    quote:
      "\u201CInsightful \u2014 allows for introspection for change and action.\u201D",
    name: "Noleen",
  },
  {
    quote:
      "\u201CThe tools and guidance provided were invaluable. I feel empowered to take control of my life again.\u201D",
    name: "Sililo",
  },
  {
    quote:
      "\u201CThrive helped me see the importance of mind management daily.\u201D",
    name: "Emily White",
  },
  {
    quote:
      "\u201CThrough Thrive, I have learnt more about myself and my value not being based on what other people think about me.\u201D",
    name: "Kelsey",
  },
  {
    quote:
      "\u201CAll the modules were empowering, gave you life tools and made you rethink your situation.\u201D",
    name: "Carol",
  },
] as const;

const STAR_KEYS = ["1", "2", "3", "4", "5"] as const;

function StarRating() {
  return (
    <div aria-label="5 out of 5 stars" className="flex gap-0.5" role="img">
      {STAR_KEYS.map((n) => (
        <svg
          aria-hidden="true"
          className="h-5 w-5 fill-amber-400 text-amber-400"
          key={n}
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      ))}
    </div>
  );
}

export function ThriveTestimonialsCarousel() {
  return (
    <div className="relative">
      {/* Edge fade overlays — pointer-events-none so cards/buttons remain interactive */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute top-0 bottom-16 left-0 z-10 w-32"
        style={{
          background:
            "linear-gradient(to right, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.6) 40%, rgba(255,255,255,0) 100%)",
        }}
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute top-0 right-0 bottom-16 z-10 w-32"
        style={{
          background:
            "linear-gradient(to left, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.6) 40%, rgba(255,255,255,0) 100%)",
        }}
      />
      <Carousel className="w-full" opts={{ loop: true }}>
        <CarouselContent className="-ml-4">
          {TESTIMONIALS.map((t) => (
            <CarouselItem className="pl-4 md:basis-1/2" key={t.name}>
              <div className="flex h-full flex-col gap-4 rounded-2xl border bg-card p-6 shadow-sm">
                <StarRating />
                <p className="body-base flex-1">{t.quote}</p>
                <span className="font-semibold text-sm">{t.name}</span>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <div className="mt-6 flex items-center gap-2 px-1">
          <CarouselPrevious className="static translate-y-0" />
          <CarouselNext className="static translate-y-0" />
        </div>
      </Carousel>
    </div>
  );
}
